/** Gedeelde stijl voor keuzeknoppen (pillen): actief = volle achtergrondkleur, geen dikke rand. */
export const chip = (active: boolean) =>
  `flex min-h-11 items-center gap-2 whitespace-nowrap rounded-2xl px-4 text-sm font-semibold transition-all duration-150 active:scale-95 ${
    active ? 'bg-slate-900 text-slate-50 dark:bg-slate-100 dark:text-slate-900' : 'bg-black/5 dark:bg-slate-800/80'
  }`;
